const moodElements = [
  {
    id: 1,
    title: 'Happy',
    color: '#FFD600',
    description: 'joyful, relax, great',
  },
  {
    id: 2,
    title: 'Proud',
    color: '#FF7A00',
    description: 'productive, motivated, alive',
  },
  {
    id: 3,
    title: 'Sad',
    color: '#1B64D2',
    description: 'lonely, depressed, numb',
  },
  {
    id: 4,
    title: 'Lazy',
    color: '#00B0FF',
    description: 'tired, sick, bored, dull',
  },
  {
    id: 5,
    title: 'Angry',
    color: '#FF0022',
    description: 'anxious, frustrated, annoyed',
  },
];

export default moodElements;
